import * as React from "react";

import { ModelHunk } from "../../../Engine/Core/ModelStoring/ModelHunk";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

export type DataPasteCallback = (clipboardContent: DataTransfer, context: DataPasteContext) => DatePasteStatus;

export interface DataPasteContext {
    bindingPath: AbsoluteModelPath;
}

export const DataPasteContext = React.createContext<DataPasteCallback>(() => DatePasteStatus.Failure);

export type RegisterTableDataPasteFunction = (
    clipboardContent: string[][],
    context: DataPasteContext,
    columnIndex: number
) => DatePasteStatus;

export enum DatePasteStatus {
    SuccessOne,
    SuccessAll,
    Failure,
}

export interface MultilineDataPasteContext {
    registerMultilinePasteFunc: (func: RegisterTableDataPasteFunction) => void;
}

export const MultilineDataPasteContext = React.createContext<MultilineDataPasteContext>({
    registerMultilinePasteFunc: () => {
        /* empty*/
    },
});

export interface TableDataPasteContext {
    registerRowDataPasteFunc: (func: RegisterTableDataPasteFunction, index: number) => void;
    fillMultiline: (bindingPath: AbsoluteModelPath, values: ModelHunk, newInstanceCount: number) => void;
    processTableDataPaste: (
        clipboardContent: DataTransfer,
        context: DataPasteContext,
        startIndex?: number,
        columnStartIndex?: number
    ) => DatePasteStatus;
}
